import React, {Component} from 'react';
import PropTypes from 'prop-types';


import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Info';
import { ListItemButton } from '@mui/material';

const s:any = {
  active: {
    color: 'primary.main',
    fontWeight: 'typography.fontWeightMedium',
  },
  nested: {
    display: 'block',
  },
  itemicon: {
    minWidth: 28,
    color: '#737978',
  }
};

class DynamicMenuChild extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  
  componentDidMount() {
    // So we only run this logic once.
    if (!this.props.openImmediately) {
      return;
    }

    // Center the selected item in the list container.
    const activeElement = document.querySelector(`.${this.props.classes.active}`);
    if (activeElement && activeElement.scrollIntoView) {
      activeElement.scrollIntoView({});
    }
  }

  render() {
    const {
      children,
      classes,
      index,
      action,
      onClick,
      openImmediately,
      title,
      ...other
    } = this.props;
    
    const {activeid} = this.props;
    const active = (index === activeid);

    return (
      <ListItem onClick={onClick(null,action,index)} {...other} disablePadding sx={{...s.nested}}>
        <ListItemButton
          selected={active}
          sx={{
            minHeight: 42,
            mx: 0.5,
            my: 0.1,
            pl: 1.4,
            pr: 1.25,
            borderRadius: '7px',
            color: '#5B6160',
            '&:hover': {
              bgcolor: '#FFF5EB',
              color: '#923A00',
              '& .MuiListItemIcon-root': { color: '#D65E00' },
            },
            '&.Mui-selected': {
              bgcolor: '#FFE5C7',
              color: '#923A00',
              '& .MuiListItemIcon-root': { color: '#D65E00' },
            },
          }}
        >
          <ListItemIcon sx={{...s.itemicon}}>
            <MenuIcon sx={{ fontSize: 17 }} />
          </ListItemIcon>
          <ListItemText
            primary={title}
            primaryTypographyProps={{ fontSize: 13, fontWeight: 600, noWrap: true }}
          />
        </ListItemButton>
      </ListItem>
    );
    
  }
}

DynamicMenuChild.propTypes = {
  //classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  openImmediately: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

DynamicMenuChild.defaultProps = {
  openImmediately: false,
};

export default DynamicMenuChild;
